import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'
import indexWrapper from '../views/indexWrapper.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'homeWrapper',
    component: indexWrapper
  },
  {
    path: '/index',
    name: 'home',
    component: index
  },
  {
    path: '/memberLogin',
    name: 'mmeberLogin',
    component: () => import('../views/memberLogin.vue')
  },
  {
    path: '/modifyIndex',
    name: 'modifyIndex',
    component: () => import('../views/modifyIndex.vue')
  },
  {
    path: '/standardEdit',
    name: 'standardEdit',
    component: () => import('../views/modifyStandardIndex.vue')
  },
  {
    path: '/enterpriseDetail',
    name: 'enterpriseDetail',
    component: () => import('../views/enterpriseDetail.vue')
  },
  {
    path: '/newsList',
    name: 'newsList',
    component: () => import('../views/newsList.vue')
  },
  {
    path: '/enterprisePolicy',
    name: 'enterprisePolicy',
    component: () => import('../views/enterprisePolicy.vue')
  },
  {
    path: '/policyDetail',
    name: 'policyDetail',
    component: () => import('../views/policyDetail.vue')
  },
  {
    path: '/addressManagement',
    name: 'addressManagement',
    component: () => import('../views/addressManagement.vue')
  },
  {
    path: '/user',
    name: 'user',
    component: () => import('../views/user.vue')
  },
  {
    path: '/userInfo',
    name: 'userInfo',
    component: () => import('../views/userInfo.vue')
  },
  {
    path: '/userLogin',
    name: 'userLogin',
    component: () => import('../views/userLogin.vue')
  },
  {
    path: '/addAddress',
    name: 'addAddress',
    component: () => import('../views/addAddress.vue')
  },
  {
    path: '/auth',
    name: 'auth',
    component: () => import('../views/auth.vue')
  },
  {
    path: '/userAuth',
    name: 'userAuth',
    component: () => import('../views/userAuth.vue')
  },
  // 通用列表
  {
    path: '/list',
    name: 'list',
    component: () => import('../views/list.vue')
  },
  // 通用列表详情
  {
    path: '/listDetail',
    name: 'listDetail',
    component: () => import('../views/listDetail.vue')
  },
  {
    path: '/authEnterprise',
    name: 'authEnterprise',
    component: () => import('../views/authEnterprise.vue')
  },
  {
    path: '/enterpriseList',
    name: 'enterpriseList',
    component: () => import('../views/enterpriseList.vue')
  },
  {
    path: '/submitBusiness',
    name: 'submitBusiness',
    component: () => import('../views/submitBusiness.vue')
  },
  {
    path: '/workOrder',
    name: 'workOrder',
    component: () => import('../views/workOrderList.vue')
  },
  {
    path: '/contactPhoneList',
    name: 'contactPhoneList',
    component: () => import('../views/contactPhoneList.vue')
  },
  {
    path: '/articleDetail',
    name: 'articleDetail',
    component: () => import('../views/articleDetail.vue')
  },
  {
    path: '/governmentService',
    name: 'governmentService',
    component: () => import('../views/governmentService.vue')
  },
  {
    path: '/faceAuth',
    name: 'faceAuth',
    component: () => import('../views/faceAuth.vue')
  }
]

const router = new VueRouter({
  base: '/jnqbqszmp',
  routes
})

export default router
